// extracted by mini-css-extract-plugin
export var button = "styles-module--button--1s0qB";